/* ka-nav.js — slide-out menu (R36 T38). Markup lives in sections/ka-nav.liquid.
   Levels are inert <template data-ka-level="id" data-title="..."> elements:
   the root level is cloned on first open, a deeper level on its first
   drill-in, so row photos only fetch then (R22 perf rule). */
(function () {
  var ham      = document.getElementById('ka-ham-btn');
  var drawer   = document.getElementById('ka-nav-drawer');
  var closeBtn = document.getElementById('ka-nav-close');
  var scrim    = document.getElementById('ka-nav-scrim');
  var backBtn  = document.getElementById('ka-nav-back');
  var titleEl  = document.getElementById('ka-nav-title');
  var holder   = document.getElementById('ka-nav-levels');
  /* #ka-ham-btn is rendered by the header section, so bail rather than throw
     if the header is absent. */
  if (!ham || !drawer || !closeBtn || !holder) return;

  var htmlEl = document.documentElement;
  var isOpen = false;
  var stack  = ['root'];
  var levels = {};
  var resetTimer = 0;

  /* Scroll-depth shadow only: .ka-nav-scrolled once the page scrolls. */
  function updateScrollState() {
    htmlEl.classList.toggle('ka-nav-scrolled', window.scrollY > 8);
  }
  window.addEventListener('scroll', updateScrollState, { passive: true });
  updateScrollState();

  function mount(id) {
    if (levels[id]) return levels[id];
    var tpl = drawer.querySelector('template[data-ka-level="' + id + '"]');
    if (!tpl) return null;
    var el = document.createElement('div');
    el.className = 'ka-nav-level';
    el.dataset.level = id;
    el.dataset.title = tpl.dataset.title || '';
    el.appendChild(tpl.content.cloneNode(true));
    holder.appendChild(el);
    levels[id] = el;
    return el;
  }

  /* Active level = top of the stack; levels below it sit behind (slid left),
     everything else waits off to the right. Only the active level is
     reachable by keyboard. */
  function paint() {
    var top = stack[stack.length - 1];
    Object.keys(levels).forEach(function (id) {
      var el = levels[id];
      var idx = stack.indexOf(id);
      el.classList.toggle('is-active', id === top);
      el.classList.toggle('is-behind', idx > -1 && id !== top);
      el.inert = id !== top;
    });
    titleEl.textContent = levels[top].dataset.title;
    backBtn.hidden = stack.length < 2;
  }

  function focusFirst(el) {
    var f = el.querySelector('a[href], button:not([disabled])');
    if (f) f.focus({ preventScroll: true });
  }

  function go(id) {
    var el = mount(id);
    if (!el) return;
    void el.offsetWidth; /* commit the off-screen start before it slides in */
    stack.push(id);
    paint();
    el.scrollTop = 0;
    focusFirst(el);
  }

  function back() {
    if (stack.length < 2) return;
    var left = stack.pop();
    paint();
    var row = levels[stack[stack.length - 1]].querySelector('[data-go="' + left + '"]');
    if (row) row.focus({ preventScroll: true }); else focusFirst(levels[stack[stack.length - 1]]);
  }

  function resetToRoot() {
    if (stack.length < 2) return;
    drawer.classList.add('ka-nav-noanim');
    stack = ['root'];
    paint();
    void drawer.offsetWidth;
    drawer.classList.remove('ka-nav-noanim');
  }

  function open() {
    clearTimeout(resetTimer);
    mount('root');
    resetToRoot();
    paint();
    isOpen = true;
    ham.classList.add('ka-ham--open');
    ham.setAttribute('aria-expanded', 'true');
    drawer.classList.add('ka-nav-drawer--open');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.inert = false;
    htmlEl.style.overflow = 'hidden';
    focusFirst(levels.root);
  }

  function close() {
    isOpen = false;
    ham.classList.remove('ka-ham--open');
    ham.setAttribute('aria-expanded', 'false');
    drawer.classList.remove('ka-nav-drawer--open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.inert = true;
    htmlEl.style.overflow = '';
    ham.focus();
    resetTimer = setTimeout(resetToRoot, 700);
  }

  ham.addEventListener('click', function () { isOpen ? close() : open(); });
  closeBtn.addEventListener('click', close);
  scrim.addEventListener('click', close);
  backBtn.addEventListener('click', back);
  holder.addEventListener('click', function (e) {
    var b = e.target.closest('[data-go]');
    if (b) go(b.getAttribute('data-go'));
  });

  /* Keyboard: Escape closes, Tab is trapped inside the open panel
     (same approach as assets/ka-popup.js). */
  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var items = Array.prototype.filter.call(
      drawer.querySelectorAll('a[href], button:not([disabled])'),
      function (el) { return !el.closest('[inert]') && !el.closest('[hidden]') && el.tabIndex >= 0; }
    );
    if (!items.length) return;
    var first = items[0];
    var last  = items[items.length - 1];
    if (e.shiftKey && (document.activeElement === first || !drawer.contains(document.activeElement))) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && (document.activeElement === last || !drawer.contains(document.activeElement))) {
      e.preventDefault(); first.focus();
    }
  });
})();
